<div class="price-and-actions-block" [class.discount-block]="discounts?.length > 0">
  <div class="price-block-md-grid" [class.single-price]="!quantityEnabled">
    <div class="price-block">
      <div class="price">
        @if(productVariant){
        @if(productVariant?.priceWithTax | formatPrice | async; as productPrice){
        <span>{{productPrice}}</span>
        } @else {
        <div class="loader-wrapper p-unset">
          <p-progressSpinner styleClass="c-loader medium centered-vertically " strokeWidth="2"
            fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
        </div>
        }
        }

      </div>
      @if (true) {
      <div class="including-vat-line">
        <span>
          Incl. VAT
        </span>
      </div>
      }
      @if (false) {
      <div class="price-before-discount-line">
        <span>
          20.000 kr
        </span>
      </div>
      }
    </div>

    @if (quantityEnabled) {
    <div class="d-md-none">
      <app-quantity-selector (quantityChangeForCart)="setQuantity($event)" [order]="activeOrder$ | async"
        [productVariant]="productVariant" [(quantity)]="quantity" [darkMode]="true"></app-quantity-selector>
    </div>
    }
  </div>

  <div class="d-none d-md-block">
    <app-item-benefits [darkMode]="false" [benefits]="itemBenefits"></app-item-benefits>
  </div>


  <div class="cto-wrapper">
    @if (shippingEnabled) {
    <div class="mb-20-px w-100">
      <app-shipping-selector [shippingMethods]="shippingMethods" [darkMode]="true"></app-shipping-selector>
    </div>
    }

    @if (quantityEnabled) {
    <div class="mb-20-px w-100 d-none d-md-block">
      <app-quantity-selector (quantityChangeForCart)="setQuantity($event)" [order]="activeOrder$ | async"
        [productVariant]="productVariant" [(quantity)]="quantity" [darkMode]="true"></app-quantity-selector>
    </div>
    }


    <div class="w-100" [class.mb-20-px]="false">
      <app-cart-button [orderLineInCart]="orderLineInCart" (subscribeToNewActiveOrder)="subscribeToActiveOrder()"
        [productVariant]="productVariant" [selectedAsset]="selectedAsset" [(quantity)]="quantity"
        [qtyInCart]="qtyInCart"></app-cart-button>
    </div>
  </div>

  <div class="d-md-none d-block">
    <app-item-benefits [darkMode]="false" [benefits]="itemBenefits"></app-item-benefits>
  </div>

  <div class="sub-actions mt-20-px">
    @if(stockLevel > 0){
    <span class="in-stock-text">{{productVariant?.stockLevel}} in stock at supplier warehouse</span>
    } @else {
    <span class="in-stock-text"><b>Sold out</b></span>
    }

    @if(enableSavedItems){
    @if (!productInSaved) {
    <a (click)="addItemToSaved()" pRipple class="save-action">Save for later</a>
    } @else {
    <a (click)="addItemToSaved()" pRipple class="save-action">Remove</a>
    }
    }


  </div>

</div>
